import { TierTwoStepType } from 'data/types'

import * as AT from './actionTypes'

export type SubmitTierTwoActionType = {
  payload: { readonly step: TierTwoStepType }
  type: typeof AT.SUBMIT
}

export type TierTwoActionType =
  | SubmitTierTwoActionType
  | { type: typeof AT.GET_VERIF }
  | { type: typeof AT.SYNC_VERIFF }

const getVerif = (): TierTwoActionType => ({
  type: AT.GET_VERIF
})

const submit = (step: TierTwoStepType): TierTwoActionType => ({
  payload: { step },
  type: AT.SUBMIT
})

const syncVeriff = (): TierTwoActionType => ({
  type: AT.SYNC_VERIFF
})

export default { getVerif, submit, syncVeriff }
